import styled from '@emotion/styled';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';

export const Button = styled.button<{isSettings:boolean}>`
  margin-left: ${props => props.isSettings?"unset" : "auto"};
  width: 30px;
  display:flex;
  align-items: center;
  /* margin-right: 9px; */
  z-index: 20;
  position: relative;

  ${mq(Devices.tablet)} {
    margin-right: 0px;
  }

  svg {
    width:100%;
    height:100%;
    fill: ${props => props.theme.colors.mainTextColor};
  }
`;

export const NotificationCount = styled.div`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 14px;
  height: 14px;
  background: red;
  color: #fff;
  font-size: 8px;
  font-weight: 600;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;